import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { StyledLink } from "components/StyledUI";
import { ROUTES } from "constants/routes";

export type TermsHintType = "overview" | "__SB__" | "seller";

interface TermsHintProps {
  type?: TermsHintType;
}

const TermsHint: FC<TermsHintProps> = ({ type = "__SB__" }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const breakpointDownXs = useMediaQuery(theme.breakpoints.down("sm"));

  const { startText, termsLink, endText } = useMemo(() => {
    switch (type) {
      case "overview":
        return {
          startText: t("cart.termsHintEach"),
          termsLink: `${t("cart.termsLink")}.`,
          endText: t("cart.termsHintEnd"),
        };
      case "seller":
        return {
          startText: t("cart.termsHintSeller"),
          termsLink: t("cart.termsLink"),
          endText: `${t("cart.termsHintSellerEnd")}.`,
        };
      case "__SB__":
      default:
        return {
          startText: t("cart.termsHint"),
          termsLink: `${t("cart.termsLink")}.`,
          endText: t("cart.termsHintEnd"),
        };
    }
  }, [type, t]);

  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: breakpointDownXs ? 10 : undefined,
      }}>
      {startText} <StyledLink to={ROUTES.TERMS}>{termsLink}</StyledLink>{" "}
      {endText}
    </Typography>
  );
};

export default TermsHint;
